export const LIST_MOVIE_HOMEPAGE_REQUEST = "@@listMovieHomepageReducer/LIST_MOVIE_HOMEPAGE_REQUEST";
export const LIST_MOVIE_HOMEPAGE_SUCCESS ="@@listMovieHomepageReducer/LIST_MOVIE_HOMEPAGE_SUCCESS";
export const LIST_MOVIE_HOMEPAGE_FAIL ="@@listMovieHomepageReducer/LIST_MOVIE_HOMEPAGE_FAIL";
export const SEARCH_FILM ="@@listMovieHomepageReducer/SEARCH_FILM";